module.exports = __webpack_public_path__ + "img/news2-1.13d1aba9.png";